import { trackPromise } from "react-promise-tracker";
import { axiosBridge } from "../network/AxiosBridge";
import { API_URL, StatusCodes } from '../network/Configurations';

const assignLabelToAudition = (params: any): Promise => {
    return new Promise((resolve, reject) => {
        trackPromise(
            axiosBridge.post(API_URL.ASSIGN_JOB_LABEL, {}, { params })
                .then(response => {
                    if (response.data.code === StatusCodes.SUCCESS) {
                        resolve(response.data)
                    } else reject(response.data)
                })
                .catch((error) => {
                    console.log(error.response);
                    reject(error);
                })
        );
    });
}

const markAuditionVerified = (params: any): Promise => {
    return new Promise((resolve, reject) => {
        trackPromise(
            axiosBridge.put(API_URL.MARK_JOB_VERIFIED, {}, { params })
                .then(response => {
                    if (response.data.code === StatusCodes.SUCCESS) {
                        resolve(response.data)
                    } else reject(response.data)
                })
                .catch((error) => {
                    console.log(error.response);
                    reject(error);
                })
        );
    });
}

const updateAudition = (request: any): Promise => {
    return new Promise((resolve, reject) => {
        trackPromise(
            axiosBridge.put(API_URL.UPDATE_ROLE_TYPE, request)
                .then(response => {
                    if (response.data.code === StatusCodes.SUCCESS) {
                        resolve(response.data)
                    } else reject(response.data)
                })
                .catch((error) => {
                    console.log(error.response);
                    reject(error);
                })
        );
    });
}

const deleteAudition = (params: any): Promise => {
    return new Promise((resolve, reject) => {
        trackPromise(
            axiosBridge.delete(API_URL.DELETE_JOB, { params })
                .then(response => {
                    if (response.data.code === StatusCodes.SUCCESS) {
                        resolve(response.data)
                    } else reject(response.data)
                })
                .catch((error) => {
                    console.log(error.response);
                    reject(error);
                })
        );
    });
}

const getAuditionById = (params: any): Promise => {
    return new Promise((resolve, reject) => {
        trackPromise(
            axiosBridge.get(API_URL.GET_AUDITION_BY_ID, { params })
                .then(response => {
                    if (response.data.code === StatusCodes.SUCCESS) {
                        resolve(response.data)
                    } else reject(response.data)
                })
                .catch((error) => {
                    console.log(error.response);
                    reject(error);
                })
        );
    });
}

const getAuditionList = (params = undefined): Promise => {
    return new Promise((resolve, reject) => {
        trackPromise(
            axiosBridge.get(API_URL.GET_AUDITIONS_LIST, { params })
                .then(response => {
                    if (response.data.code === StatusCodes.SUCCESS || response.data.code === StatusCodes.NO_DATA_FOUND) {
                        resolve(response.data)
                    } else reject(response.data)
                })
                .catch((error) => {
                    console.log(error.response);
                    reject(error);
                })
        );
    });
}

export const AuditionService = {
    assignLabelToAudition,
    markAuditionVerified,
    updateAudition,
    deleteAudition,
    getAuditionById,
    getAuditionList,
}